import { z } from 'zod/v4';

import { regionDetailsSchema } from './region-details.schema';

export const majorRegionSchema = z.object({
  minorRegions: z.array(regionDetailsSchema),
  regionDetails: regionDetailsSchema,
});

export type MajorRegion = z.infer<typeof majorRegionSchema>;
